import { render, staticRenderFns } from "./collaborators_indicator.vue?vue&type=template&id=be0537e8&vue3"
import script from "./collaborators_indicator.vue?vue&type=script&lang=js&vue3"
export * from "./collaborators_indicator.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports